// No user id is stored in localStorage separately from the JWT - it's
// already in there (see Backend/utils/tokenOperations.js's generateAccessToken),
// so just decode the payload rather than threading a new field through the
// whole login flow.
export function getMyUserId() {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.id;
    } catch (error) {
        return null;
    }
}

// UI-gating convenience only, never a security boundary - every admin
// request is re-authorized server-side against the live database role
// (see Backend/utils/tokenOperations.js's requireAdminRole), so a stale
// 'admin' claim in an as-yet-unrefreshed token can only make the client
// briefly still show admin UI, never actually perform an admin action.
export function getMyRole() {
    const token = localStorage.getItem('accessToken');
    if (!token) return 'user';
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.role || 'user';
    } catch (error) {
        return 'user';
    }
}
